module.exports = __webpack_public_path__ + "static/img_2471-cd5458322e5628b747b5b2e484a518c9.webp";